var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},_vm._l((_vm.pages),function(page,index){return _c('div',{key:index},[_c('TemplateMonthlyAccountPayableSupplyList',{attrs:{"id":`page-${index}`}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }